import type {
  BadgeAssigneeBoolExp,
  EventBoolExp,
  TeamBoolExp,
} from '@/gql/scalars';

export type PersonScope =
  | { kind: 'none' }
  | { kind: 'team'; id: string }
  | { kind: 'organization'; id: string };

export function personScopeEventWhere(id: string): EventBoolExp {
  return {
    _or: [{ id: { _eq: id } }, { path_ancestors: { parent_id: { _eq: id } } }],
  };
}

export function personScopeTeamWhere(scope: PersonScope): TeamBoolExp {
  if (scope.kind === 'team') return { id: { _eq: scope.id } };
  if (scope.kind === 'organization')
    return { team_events: { event: personScopeEventWhere(scope.id) } };
  return { id: { _in: [] } };
}

export function personScopeBadgeWhere(
  scope: PersonScope,
): BadgeAssigneeBoolExp {
  if (scope.kind === 'team') return { team_id: { _eq: scope.id } };
  if (scope.kind === 'organization')
    return {
      _or: [
        { event: personScopeEventWhere(scope.id) },
        { event_id: { _is_null: true }, team: personScopeTeamWhere(scope) },
      ],
    };
  return { id: { _in: [] } };
}
